import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DrawerWrapper from '../../../ui/modules/DrawerWrapper'

import FiltersForm from './FiltersForm'

const FiltersDrawerView = ({
  onUpdateFilters,
  isOpen,
  setOpen,
  user,
  countries,
  filters,
  disabledFilterByStatusCode,
}) => {
  const applyFilters = updatedFilters => {
    setOpen(false)
    const newFilters = { ...filters, ...updatedFilters }
    onUpdateFilters(newFilters)
  }

  return (
    <>
      <DrawerWrapper
        isOpen={isOpen}
        onClose={() => {
          setOpen(false)
        }}
      >
        <FiltersForm
          userCentres={user.centres}
          countries={countries}
          filters={filters}
          disabledFilterByStatusCode={disabledFilterByStatusCode}
          cancel={() => {
            setOpen(false)
          }}
          confirm={applyFilters}
        />
      </DrawerWrapper>
    </>
  )
}
FiltersDrawerView.propTypes = {
  onUpdateFilters: PropTypes.func.isRequired,
  setOpen: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    centres: FiltersForm.propTypes.userCentres,
  }).isRequired,
  countries: FiltersForm.propTypes.countries,
  filters: FiltersForm.propTypes.filters,
  disabledFilterByStatusCode: FiltersForm.propTypes.disabledFilterByStatusCode,
}

export default FiltersDrawerView
